export const tipoRenglon = {
    Compra: 101,
    Venta: 102,
    Credito: 111,
    Debito: 112
}